// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.common with an alias.
import Vue from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { setupAxiosInterceptors } from '@/shared/config/axios-interceptor';

import App from './app.vue';
import Vue2Filters from 'vue2-filters';
import { ToastPlugin } from 'bootstrap-vue';
import router from './router';
import axios from 'axios';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import * as config from './shared/config/config';
import * as bootstrapVueConfig from './shared/config/config-bootstrap-vue';
import JhiItemCountComponent from './shared/jhi-item-count.vue';
import * as customVueConfig from './shared/config/config-custom-vue';
import * as apeironVueConfig from './shared/config/config-apeiron-component-vue';
import * as codeEditorVueConfig from './shared/config/config-code-editor-vue';
import JhiSortIndicatorComponent from './shared/sort/jhi-sort-indicator.vue';
import InfiniteLoading from 'vue-infinite-loading';
import HealthService from './admin/health/health.service';
import MetricsService from './admin/metrics/metrics.service';
import LogsService from './admin/logs/logs.service';
import ConfigurationService from '@/admin/configuration/configuration.service';
import LoginService from './account/login.service';
import AccountService from './account/account.service';
import AlertService from './shared/alert/alert.service';
import PollingService from './shared/polling/polling.service';
import GrantService from '@/shared/security/grant.service';
import PersonaService from '@/shared/persona/persona.service';
import PersonaMoralService from '@/shared/persona/persona-moral.service';
import InstitucionesSnpService from '@/shared/instituciones-snp/instituciones.snp.service';
import Multiselect from 'vue-multiselect';

import BuscadorCvu from '@conacyt/buscador-cvu';

import { Configuration as DmsConfiguration, DmsApi } from '@conacyt/dms-client';
import { Configuration as CvuConfiguration, CvuApi, PersonaFisicaApi, PersonaMoralApi } from '@conacyt/cvu-client';
import { Configuration as SaciConfiguration, SaciApi } from '@conacyt/saci-client';
import { Configuration as PerfilConfiguration, PerfilApi } from '@conacyt/perfil-usuario-client';

import { Configuration as NominaConfiguration, NominaApi } from '@conacyt/nomina-client';

import '../content/scss/global.scss';
import '../content/scss/vendor.scss';
import TranslationService from '@/locale/translation.service';

import GatewayService from '@/admin/gateway/gateway.service';
/* tslint:disable */

// jhipster-needle-add-entity-service-to-main-import - JHipster will import entities services here

import { insaculacionesApi, solicitudesApi } from './shared/config/api/insaculaciones';
import { Configuration as HistoricoPersonasConfiguration, HistoricoPersonasApi } from '@conacyt/historicopersonasms-client';
import { Configuration as SicobConfiguration, SicobApi } from '@conacyt/persona-moral-sicob-client';
import { Configuration as DatosGeneralesConfig, DatosGeneralesApi } from '@conacyt/persona-moral-sicob-client';
import { Configuration as SeguimientoPagoConfig, SeguimientoPagoApi } from '@conacyt/persona-moral-sicob-client';
import { Configuration as SeguimientoAdministrativoConfig, SeguimientoAdministrativoApi } from '@conacyt/persona-moral-sicob-client';
import { Configuration as ListadoApoyosConfig, ListadoApoyosApi } from '@conacyt/persona-moral-sicob-client';
import { Configuration as CatalogosApeironConfiguration, CatalogosApi } from '@conacyt/catalogos-client';
import { Configuration as ReniecytConfiguration, ReniecytApi } from '@conacyt/persona-moral-reniecyt-client';
import { Configuration as ReportesMsConfiguration, ReportesApi } from '@conacyt/reportesms-client';
import { Configuration, RenapoResourceApi } from '@conacyt/renapo-client';
import PersonalBecaService from '@/entities/seguimiento/personal-beca.service';
import VerificacionService from '@/entities/seguimiento/verificacion.service';
import PdfExbecariosService from '@/entities/exbecarios/pdf-exbecarios.service';
import CatalogoSaciService from './shared/catalogo/catalogo-saci.service';
import UserOtpService from '@/shared/services/UserOtp.service';

/* tslint:enable */
Vue.config.productionTip = false;
config.initVueApp(Vue);
config.initFortAwesome(Vue);
bootstrapVueConfig.initBootstrapVue(Vue);
customVueConfig.initCustomVue(Vue);
apeironVueConfig.initApeironComponentsVue(Vue);
codeEditorVueConfig.initCodeEditorVue(Vue);
Vue.use(Vue2Filters);
Vue.use(ToastPlugin);
Vue.use(BuscadorCvu);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('jhi-item-count', JhiItemCountComponent);
Vue.component('jhi-sort-indicator', JhiSortIndicatorComponent);
Vue.component('infinite-loading', InfiniteLoading);
Vue.component('multiselect', Multiselect);
const i18n = config.initI18N(Vue);
const store = config.initVueXStore(Vue);

const translationService = new TranslationService(store, i18n);
const pollingService = new PollingService();
const loginService = new LoginService(pollingService);
const accountService = new AccountService(store, translationService, (<any>Vue).cookie, router, pollingService);
const grantService = new GrantService(store);
const alertService = new AlertService();

// Configuración para microservicios accedidos desde el gateway
const dmsConfiguration = new DmsConfiguration({ basePath: '/services/dmsms/api' });
const cvuConfiguration = new CvuConfiguration({ basePath: '/services/cvu' });
const saciConfiguration = new SaciConfiguration({ basePath: '/services/saci' });
const perfilConfiguration = new PerfilConfiguration({ basePath: '/services/msperfil/api' });
const nominaConfiguration = new NominaConfiguration({ basePath: '/services/nominams/api' });

const historicoPersonasConfiguration = new HistoricoPersonasConfiguration({ basePath: '/services/historicopersonasms/api' });
const reportesMsConfiguration = new ReportesMsConfiguration({ basePath: '/services/reportesms/api' });
const RenapoConfiguration = new Configuration({ basePath: '/services/renapoms/api' });

const cvuInfoService = new CvuApi(cvuConfiguration);
const perfilApi = new PerfilApi(perfilConfiguration);
const sicobConfiguration = new SicobConfiguration({ basePath: '/services/sicobms/api' });
const datosGeneralesApi = new DatosGeneralesConfig({ basePath: '/services/sicobms/api' });
const seguimientoAdministrativoApi = new SeguimientoAdministrativoConfig({ basePath: '/services/sicobms/api' });
const seguimientoPagoApi = new SeguimientoPagoConfig({ basePath: '/services/sicobms/api' });
const listadoApoyosApi = new ListadoApoyosConfig({ basePath: '/services/sicobms/api' });
const catalogosApi = new CatalogosApeironConfiguration({ basePath: '/services/catalogosms/api' });
const reniecytApi = new ReniecytApi(new ReniecytConfiguration({ basePath: '/services/reniecytms/api' }));
const personalBecaService = new PersonalBecaService();
const verificacionService = new VerificacionService();
const pdfExbecariosService = new PdfExbecariosService();
const saciApi = new SaciApi(saciConfiguration);

router.beforeEach(async (to, from, next) => {
  if (!to.matched.length) {
    next('/not-found');
  } else if (to?.meta?.authorities?.length > 0) {
    accountService.hasAnyAuthorityAndCheckAuth(to.meta.authorities).then(value => {
      if (!value) {
        sessionStorage.setItem('requested-url', to.fullPath);
        next('/forbidden');
      } else {
        next();
      }
    });
  } else {
    // no authorities, so just proceed
    next();
  }
});

/* tslint:disable */
axios
  .get('sentry/config')
  .then(res => {
    if (res?.data?.dsn) {
      let environment = 'local';
      let tracesSampleRate: 0.25;

      if (res.data.environment) {
        environment = res.data['environment'];
      }

      if (res.data.tracesSampleRate) {
        tracesSampleRate = res.data['tracesSampleRate'];
      }

      Sentry.init({
        Vue,
        dsn: res.data['dsn'],
        beforeSend(event, hint) {
          // Check if it is an exception, and if so, show the report dialog
          if (event.exception) {
            let value = null;

            if (event?.exception?.values?.length) {
              value = event.exception.values.find(e => e.value.indexOf('navigation guard') != -1);
            } else {
              console.log(JSON.stringify(event.exception));
            }

            // Check isn't navigation guard exception
            if (!value) {
              let feedBackConfig;

              if (store?.getters?.account?.firstName) {
                const username = store.getters.account.lastName
                  ? `${store.getters.account.firstName} ${store.getters.account.lastName}`
                  : store.getters.account.firstName;

                feedBackConfig = { eventId: event.event_id, user: { name: username, email: store.getters.account.email } };
              } else {
                feedBackConfig = { eventId: event.event_id };
              }

              Sentry.showReportDialog(feedBackConfig);
            }
          }
          return event;
        },
        replaysSessionSampleRate: 0.1,
        // If the entire session is not sampled, use the below sample rate to sample
        // sessions when an error occurs.
        replaysOnErrorSampleRate: 1.0,
        integrations: [
          new Integrations.BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins: ['localhost', 'dev.apeiron.conacyt.mx', 'qa.apeiron.conacyt.mx', 'apeiron.conacyt.mx', /^\//],
          }),
        ],
        tracesSampleRate: tracesSampleRate,
        environment: environment,
        release: VERSION,
        dist: APP_DISTRIBUTION,
      });
    } else {
      console.log('Sentry sin activar');
    }
  })
  .catch(err => {
    console.error('Error al realizar la configuración de sentry');
    console.error(err);
  });
/* tslint:enable */

/* tslint:disable */
const app = new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
  provide: {
    loginService: () => loginService,

    gatewayService: () => new GatewayService(),
    healthService: () => new HealthService(),
    configurationService: () => new ConfigurationService(),
    logsService: () => new LogsService(),
    metricsService: () => new MetricsService(),

    translationService: () => translationService,
    // jhipster-needle-add-entity-service-to-main - JHipster will import entities services here
    accountService: () => accountService,
    grantService: () => grantService,
    alertService: () => alertService,
    pollingService: () => pollingService,
    dmsApi: () => new DmsApi(dmsConfiguration),
    cvuInfoService: () => cvuInfoService,
    personaFisicaInfoService: () => new PersonaFisicaApi(cvuConfiguration),
    personaMoralInfoService: () => new PersonaMoralApi(cvuConfiguration),
    saciApi: () => saciApi,
    insaculacionesApi: () => insaculacionesApi,
    solicitudesApi: () => solicitudesApi,
    perfilApi: () => perfilApi,
    reniecytApi: () => reniecytApi,
    historicoPersonasApi: () => new HistoricoPersonasApi(historicoPersonasConfiguration),
    reportesApi: () => new ReportesApi(reportesMsConfiguration),
    renapoApi: () => new RenapoResourceApi(RenapoConfiguration),
    personaService: () => new PersonaService(perfilApi, cvuInfoService),
    personaMoralService: () => new PersonaMoralService(reniecytApi),
    institucionesSnpService: () => new InstitucionesSnpService(),
    sicobApi: () => new SicobApi(sicobConfiguration),
    datosGeneralesApi: () => new DatosGeneralesApi(datosGeneralesApi),
    seguimientoPagoApi: () => new SeguimientoPagoApi(seguimientoPagoApi),
    seguimientoAdministrativoApi: () => new SeguimientoAdministrativoApi(seguimientoAdministrativoApi),
    listadoApoyosApi: () => new ListadoApoyosApi(listadoApoyosApi),
    catalogosApi: () => new CatalogosApi(catalogosApi),
    personalBecaService: () => personalBecaService,
    verificacionService: () => verificacionService,
    pdfExbecariosService: () => pdfExbecariosService,
    nominaApi: () => new NominaApi(nominaConfiguration),
    catalogoSaciService: () => new CatalogoSaciService(saciApi),
    userOtpService: () => new UserOtpService(),
  },
  i18n,
  store,
});

setupAxiosInterceptors(
  error => {
    const url = error.response?.config?.url;
    const status = error.status || error.response.status;
    if (status === 401) {
      // Store logged out state.
      store.commit('logout');
      if (!url.endsWith('api/account') && !url.endsWith('api/authenticate')) {
        // Ask for a new authentication
        sessionStorage.removeItem('requested-url');
        window.location.href = '/unauthorized';
        return;
      }
    }
    console.log('Unauthorized!');
    return Promise.reject(error);
  },
  error => {
    if (!error?.status && !error?.response?.status) {
      alertService.showError(app, i18n.t('error.sinStatus.message').toString());
    }
    console.log('Server error!');
    return Promise.reject(error);
  }
);
